const envObject = {
  // serviceUrl : 'http://192.168.1.102:1003/api/v1',
    serviceUrl : 'http://ssuhs-uat.universus.co.in:5003/api/v1', 
     //serviceUrl : 'https://ssuhs.universus.co.in:1004/api/v1', 
    secretkey  :  ""
};

export const environment = {
production: false,
serviceUrl: envObject.serviceUrl,
key: envObject.secretkey
};